
CustomTC.define('text!modules/transcriptions/htmls/transcriptions.html',[],function () { return '<div class="transcript"></div>';});

